import {
  takeLatest, put, call,
} from 'redux-saga/effects';
import { push } from 'connected-react-router';
import api from 'store/api';
import { toast } from 'react-toastify';
import { URL } from '../../../constants/url';
import actionTypes from '../actionTypes';

export function* setCardGame({ payload }) {
  const {
    limit,
    stackSize,
    position,
    handType,
    smartMode,
    category,
    game,
    timerIsActive,
    timerCompleted,
    fastMode,
    currentGame,
    isGameAnswerCorrect,
    ggps,
    isFreeUser = false,
    difficulty,
    challengeResults = false,
  } = payload;
  try {
    // eslint-disable-next-line no-nested-ternary
    const payloadPosition = (position.length === 1 && position[0].includes('random')) ? (position[0] === 'randomRfiNoBlinds' ? ['noblinds'] : []) : position;
    const payloadHandType = (handType.length === 1 && handType[0].includes('random')) ? [] : handType;

    // eslint-disable-next-line
    const gameIsWrong = (!isGameAnswerCorrect || (timerIsActive && timerCompleted && !fastMode && smartMode));
    const isPlo5 = sessionStorage.getItem('isPlo5') === 'true';

    const defineEndpoint = () => {
      if (isPlo5) return URL.PLO5GAME;
      if (isFreeUser) return URL.FREE_GAME;
      return URL.GAME;
    };

    const res = yield call(api, {
      method: 'post',
      url: defineEndpoint(),
      data: {
        bb: stackSize.value,
        ts: limit.value,
        position: payloadPosition,
        hand_type: payloadHandType,
        category: category.value.toLowerCase().replace(' ', ''),
        smart_mode: smartMode,
        game: isPlo5 ? game : null,
        timer: timerIsActive && !fastMode && smartMode,
        challenge_results: challengeResults,
        gg: ggps === 'gg',
        difficulty,
        wrong: (!challengeResults && currentGame?.id && gameIsWrong ? {
          id: currentGame?.id,
          bb: currentGame?.bb,
          ts: currentGame?.ts,
          stake: currentGame?.stake,
          option: currentGame?.option,
          gg: ggps === 'gg',
          category: currentGame?.category.value.toLowerCase().replace(' ', ''),
          game: isPlo5 ? currentGame?.game : null,
          difficulty: currentGame?.difficulty,
        } : null),
      },
    });
    yield put({ type: 'SET_CARD_GAME_SUCCESS', payload: res.data });
  } catch (e) {
    if (e.message !== 'token contains an invalid number of segments') {
      yield call(toast.error, e.message);
    }
    if ((e.originalMessage || e.message) === 'your subscription does not allow you to use this service') {
      yield put(push('/profile'));
    }
    yield put({ type: 'SET_CARD_GAME_ERROR' });
  }
}

export default function* listener() {
  yield takeLatest(actionTypes.SET_CARD_GAME, setCardGame);
}
